const MIN_DESIGN_PROJECTS = 6;

const MIN_MUSIC_PHOTO_PROJECTS = 3;

const MIN_VIDEO_PROJECTS = 1;

export { MIN_DESIGN_PROJECTS, MIN_MUSIC_PHOTO_PROJECTS, MIN_VIDEO_PROJECTS };
